import { Download, Share } from 'lucide-react';
import React from 'react';
import { Button } from 'src/components/ui/button';
import AiStar from "src/assets/icons-redesign/ai-star.svg?react";
import { SurveyFull } from 'src/redux/survey/survey.types';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/components/ui/tooltip';

interface OverviewHeaderProps {
  survey?: SurveyFull;
}

const OverviewHeader: React.FC<OverviewHeaderProps> = ({ survey }) => {
  return (
    <div className="px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <TooltipProvider delayDuration={300}>
            <Tooltip>
              <TooltipTrigger asChild>
                <h1 className="text-3xl text-gray-900">
                  {survey?.title}
                </h1>
              </TooltipTrigger>
              <TooltipContent
                side="bottom"
                className="max-w-md"
              >
                {survey?.title}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            className="bg-gray-800 text-white hover:bg-gray-500"
            size="icon"
          >
            <Download className="size-10" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="bg-gray-201 text-gray-900 hover:bg-gray-700 hover:text-white"
          >
            <Share className="size-10" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="bg-purple-500 text-white hover:bg-purple-600"
          >
            <AiStar className="size-10 text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OverviewHeader;
